import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function BillingSuccess() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [params] = useSearchParams();

  useEffect(() => {
    const sid = params.get("session_id");
    (async () => {
      try {
        if (sid) await api.get(`/billing/status?session_id=${sid}`);
      } catch {}
      const u = await refresh();
      toast.success("You're upgraded! 🎉 Enjoy the extra swaps and slots.");
      nav("/dashboard", { replace: true });
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground" data-testid="billing-success">
      <Loader2 size={26} className="animate-spin text-primary" />
      <div className="font-mono text-sm text-muted-foreground mt-4 tracking-wide">Confirming your subscription…</div>
    </div>
  );
}
